import React, {useState, useContext, useEffect} from 'react';
import { IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonHeader, IonContent, IonFooter, IonItem } from '@ionic/react';

import '../../../css/layout.css';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';


export function ShowRoomPicsModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [accessRights, setAccessRights ] = useState(authenticatedMerchent_context.accessRights);


    let [roomImageNumber, setRoomImageNumber] = useState(null);

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);
    let [takePhotoStatus2, setTakePhotoStatus2] = useState(false);
    let [takePhotoStatus3, setTakePhotoStatus3] = useState(false);
    let [takePhotoStatus4, setTakePhotoStatus4] = useState(false);

    let [selectedFile, setSelectedFile] = useState(null);



    function selectedFileHandler1(event)
    {
        setRoomImageNumber("1");
        setSelectedFile(event);
        setTakePhotoStatus1(false);
    }

    function selectedFileHandler2(event)
    {
        setRoomImageNumber("2");
        setSelectedFile(event);
        setTakePhotoStatus2(false);
    }
    function selectedFileHandler3(event)
    {
        setRoomImageNumber("3");
        setSelectedFile(event);
        setTakePhotoStatus3(false);
    }
    function selectedFileHandler4(event)
    {
        setRoomImageNumber("4");
        setSelectedFile(event);
        setTakePhotoStatus4(false);
    }

    function handleFileChange(event) {

        // alert("in HadndleFileChange");
        // alert(event[0]);
        // alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        // const file = event.target.files ? event.target.files[0] : null;
        // setRoomImageNumber(event.target.dataset.id);
        // setSelectedFile(file);

        if(event.target.dataset.id == "1")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setRoomImageNumber("1");
            setSelectedFile(file);
        }
        if(event.target.dataset.id == "2")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setRoomImageNumber("2");
            setSelectedFile(file);
        }
        if(event.target.dataset.id == "3")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setRoomImageNumber("3");
            setSelectedFile(file);
        }
        if(event.target.dataset.id == "4")
        {
            const file = event.target.files ? event.target.files[0] : null;
            setRoomImageNumber("4");
            setSelectedFile(file);
        }
    }

    function handleEnterAttachement(event) {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setRoomImageNumber(event[0]);
            setSelectedFile(noImageFile);

            alert("No Photo Option checked");
        })
    }



    function uploadRoomImage()
    {
    
        let formData = new FormData();
        formData.append('Tracker', '74300_Pic');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xInventoryRoomID', props.data.roomID);
        formData.append('xRoomImageNumber', roomImageNumber);
        formData.append('xImageFile', selectedFile);
        formData.append('xEnterAdminPassword', accessRights[0]);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,

            
            // body: JSON.stringify({
            //     Tracker: '74300_Pic',
            //     user: acctID,
            //     xInventoryRoomID: props.data.roomID,
            //     xRoomImageNumber: roomImageNumber,
            //     xImageFile: selectedFile,
            //     xEnterAdminPassword: enteredPassword,
            //     sessionID: sessionID,

            // }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    // function onSubmitPasswordHandler(enteredPassword)
    // {
    //     //alert('In onSubmitPasswordHandler');
    //     //alert(enteredPassword);

    //     //setEnteredPassword(event);
    //     uploadRoomImage(enteredPassword);
    // }

    function closeModalHandler() {

        props.closeModal(false);
    }

    //alert('Inside ShowRoomPicsModal');
    //alert(props.data.roomPic1);
    //alert(props.data.roomPic2);
    //alert(props.data.roomPic3);
    //alert(props.data.roomPic4);


    return (
        <React.Fragment>
        {props.openModal == true ?
            (
        <IonModal id='showRoomPics' isOpen={ props.openModal }>
        <IonHeader className='appModalHeader'>
            <IonGrid class='gridModalTopInfo'>
                        <IonRow>
                            <IonCol> Room ID</IonCol>
                            <IonCol> Price Per Night</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol> {props.data.roomID} </IonCol>
                            <IonCol> {props.data.roomSalePrice} </IonCol>
                        </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='grid_content'>
            <IonSlides pager='true' options={{direction: 'horizontal'}}>
                <IonSlide>
                    <IonGrid  className='grid_content'>
                        <IonRow>
                            <IonCol> 1/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                                {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='1'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <label for='noAttachment'>No Attachment</label>
                            </IonCol>
                            <IonCol>
                                <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement(['1'])}></input>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => uploadRoomImage()}> Submit Upload </IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.roomPic1}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  className='grid_content'>
                        <IonRow>
                            <IonCol> 2/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus2(true)}> Take Photo</IonButton>
                                {takePhotoStatus2 == true && <TakePhoto onSelectedFile={selectedFileHandler2}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='2'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <label for='noAttachment'>No Attachment</label>
                            </IonCol>
                            <IonCol>
                                <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement(['2'])}></input>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => uploadRoomImage()}> Submit Upload </IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.roomPic2}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  className='grid_content'>
                        <IonRow>
                            <IonCol> 3/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus3(true)}> Take Photo</IonButton>
                                {takePhotoStatus3 == true && <TakePhoto onSelectedFile={selectedFileHandler3}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='3'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <label for='noAttachment'>No Attachment</label>
                            </IonCol>
                            <IonCol>
                                <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement(['3'])}></input>
                            </IonCol>
                        </IonRow>
                        
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => uploadRoomImage()}> Submit Upload </IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonImg src={`/api/image/${props.data.roomPic3}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid  className='grid_content'>
                        <IonRow>
                            <IonCol> 4/4 </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>                            
                                <IonButton  onClick={() => setTakePhotoStatus4(true)}> Take Photo</IonButton>
                                {takePhotoStatus4 == true && <TakePhoto onSelectedFile={selectedFileHandler4}></TakePhoto>}
                            </IonCol>
                            <IonCol>
                                <input
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='4'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <label for='noAttachment'>No Attachment</label>
                            </IonCol>
                            <IonCol>
                                <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement(['4'])}></input>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => uploadRoomImage()}> Submit Upload </IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                            <IonImg src={`/api/image/${props.data.roomPic4}/${schema}`} />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
            </IonSlides>
        </IonContent>

        <IonFooter class='appFooter'>

            <IonButton onClick={closeModalHandler}> Close </IonButton>

        </IonFooter>

        {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>   */}                     

        </IonModal>) : null }
        </React.Fragment>
    )
}